module.exports = __webpack_public_path__ + "img/11.597d8a3c.svg";